<template>
  <div class="asc-derived-parameters">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AscDerivedParameters',
}
</script>
